import type { ReactNode } from 'react';
import { PanelLeft } from 'lucide-react';
import { Button } from '@reflex/ui/components/ui/button';
import { Tooltip, TooltipTrigger, TooltipContent } from '@reflex/ui/components/ui/tooltip';

interface CollapsedSidebarRailProps {
  onToggle: () => void;
  children: ReactNode;
}

export function CollapsedSidebarRail({ onToggle, children }: CollapsedSidebarRailProps) {
  return (
    <div
      data-testid="collapsed-sidebar-rail"
      className="flex h-full w-12 flex-col items-center border-r border-border bg-sidebar py-3 gap-2"
    >
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8"
            onClick={onToggle}
            aria-label="Expand sidebar"
          >
            <PanelLeft className="h-4 w-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="right">Expand sidebar</TooltipContent>
      </Tooltip>

      {children}
    </div>
  );
}
